import React, { useState } from 'react';
import dateFormat from 'dateformat';
import Table from '../../layout/forms/Table'
import { useEffect,useRef } from 'react';
import apiObjectAttributesHistory from '../../../api/objectAttributes';
import AppForAttributeHistory from '../../home/report/AppForAttributeHistory';

const ObjectAttributesHistory = ({ selectedGlobalObjectKey }) => {
    const [attributes, setAttributes] = useState([]);
    const tableRef = useRef();
    useEffect(() => {
        if (selectedGlobalObjectKey === null) {
            setAttributes([]);
            return;
        }            
        const reloadAttribute = async () => {
            const dataAttributes = await apiObjectAttributesHistory.get(
                selectedGlobalObjectKey
            );
            setAttributes(dataAttributes);
        }
        reloadAttribute();
    }, [selectedGlobalObjectKey]);
    console.log(attributes);
    let index = 0;
    const data = attributes.map(attribute => {
        const result = ({ ...attribute, id: index })
        index++;
        return result;
    }).reduce((all, attribute) => {

        const histories = [...attribute.objectAttributeHistories];
        histories.sort((a, b) => {
            if (a.version === b.version) {
                return 0;
            }
            return a.version < b.version ? 1 : -1;
        });
        return [
            ...all,
            ...[{
                id: attribute.id,
                description: histories[0].description,
                value: histories[0].value,
                engineeringUnit: histories[0].engineeringUnit,
                system: histories[0].system,
                version: histories[0].version,
                beginDate: histories[0].beginDate,
                endDate:histories[0].endDate
            }],
            ...histories.map(history => {

                const result = {
                    id: index,
                    parentId: attribute.id,
                    ...history
                }
                index++;
                return result;
            })
        ]
    },
        []
    );
    return (
        <div>                   
            <Table tableId={"Object attributesHistory"}
                className={null}
            rowsPerPage={100}
            data={data}
            columns={[
                { title: 'Description', field: 'description', width: 200 },
                { title: 'Value', field: 'value', width: 200 },
                { title: 'Unit', field: 'engineeringUnit', width: 200 },
                { title: 'System', field: 'system', width: 200 },
                { title: 'Version', field: 'version', width: 200 },
                { title: 'Begin Date', field: 'beginDate', width: 200 },            
                { title: 'End Date', field: 'endDate', width: 200 },
            ]}
                parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
            />
        </div>
    );
};
export default ObjectAttributesHistory;
